import { Box, Button, Typography } from "@mui/material";
import { useBoundStore } from "useStore";
import { useShallow } from "zustand/react/shallow";

export default function AdsDeleteButton({ row }) {
  const markAdsDeleted = useBoundStore((state) => state.markAdsDeleted);
  const unmarkAdsDeleted = useBoundStore((state) => state.unmarkAdsDeleted);
  const isDeleted = useBoundStore(
    useShallow((state) => !!state.adsEditedRows[row.itemId]?._deleted),
  );

  const handleClick = () => {
    if (isDeleted) {
      unmarkAdsDeleted(row.itemId);
    } else {
      markAdsDeleted(row);
    }
  };

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        height: "100%",
      }}
    >
      <Button
        onClick={handleClick}
        sx={{
          padding: "10px 16px",
          height: "32px",
          backgroundColor: "#FFFFFF",
          color: isDeleted ? "#002878" : "#000000DE",
          border: isDeleted ? "1px solid #002878" : "1px solid #0000003B",
          borderRadius: "8px",
        }}
      >
        <Typography variant="body2" fontWeight={400} size="small">
          Eliminar
        </Typography>
      </Button>
    </Box>
  );
}
